class HeaderSearchExpand {
  constructor() {
    this.searchContainer = document.querySelector('[data-search-container]');

    // Desktop elements
    this.searchWrapper = this.searchContainer?.querySelector('.header__search-wrapper-desktop');
    this.searchCompact = this.searchContainer?.querySelector('[data-search-compact]');
    this.searchPlaceholder = this.searchContainer?.querySelector('[data-search-placeholder]');
    this.searchValue = this.searchContainer?.querySelector('[data-search-value]');
    this.searchInput = this.searchContainer?.querySelector('[data-search-input]');
    this.searchIcon = this.searchContainer?.querySelector('[data-search-icon]');
    this.searchClose = this.searchContainer?.querySelector('[data-search-close]');
    this.searchForm = this.searchContainer?.querySelector('[data-search-form]');

    // Mobile elements
    this.searchWrapperMobile = this.searchContainer?.querySelector('.header__search-wrapper-mobile');
    this.searchCompactMobile = this.searchContainer?.querySelector('[data-search-compact-mobile]');
    this.searchPlaceholderMobile = this.searchContainer?.querySelector('[data-search-placeholder-mobile]');
    this.searchValueMobile = this.searchContainer?.querySelector('[data-search-value-mobile]');
    this.searchInputMobile = this.searchContainer?.querySelector('[data-search-input-mobile]');
    this.searchIconMobile = this.searchContainer?.querySelector('[data-search-icon-mobile]');
    this.searchCloseMobile = this.searchContainer?.querySelector('[data-search-close-mobile]');
    this.searchFormMobile = this.searchContainer?.querySelector('[data-search-form-mobile]');

    this.header = document.querySelector('.header');
    this.animationMs = 520;
    this.desktopCollapseTimer = null;
    this.mobileCollapseTimer = null;

    if (this.searchWrapper && this.searchInput) {
      this.initDesktop();
    }

    if (this.searchWrapperMobile && this.searchInputMobile) {
      this.initMobile();
    }
  }

  initDesktop() {
    // Pokud input už má hodnotu (např. po vyhledání), zobrazit hodnotu místo placeholderu
    this.updateValueDisplay();
    if (this.searchInput.value.trim()) {
      this.searchWrapper.classList.add('has-value');
    }

    // Kliknutí na placeholder - rozšířit
    if (this.searchPlaceholder) {
      this.searchPlaceholder.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!this.isExpandedDesktop()) {
          this.expandDesktop();
        }
      });
    }

    // Kliknutí na compact div (mimo ikonu a křížek) - rozšířit
    if (this.searchCompact) {
      this.searchCompact.addEventListener('click', (e) => {
        if (!this.searchIcon.contains(e.target) && !this.searchClose?.contains(e.target)) {
          if (!this.isExpandedDesktop()) {
            this.expandDesktop();
          }
        }
      });
    }

    // Kliknutí na ikonu lupy - rozšířit nebo submit
    this.searchIcon.addEventListener('click', (e) => {
      e.stopPropagation();
      if (this.isExpandedDesktop()) {
        this.submitSearchDesktop();
      } else {
        this.expandDesktop();
      }
    });

    this.searchIcon.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.searchIcon.click();
      }
    });

    // Kliknutí na křížek - zavřít
    if (this.searchClose) {
      this.searchClose.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.collapseDesktop();
      });
    }

    // Aktualizovat třídu a zobrazení hodnoty při psaní
    this.searchInput.addEventListener('input', () => {
      this.updateValueDisplay();
      if (this.searchInput.value.trim()) {
        this.searchWrapper.classList.add('has-value');
      } else {
        this.searchWrapper.classList.remove('has-value');
      }
    });

    // Enter - submit
    this.searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.submitSearchDesktop();
      }
    });

    // Kliknutí mimo - sbalit
    document.addEventListener('click', (e) => {
      if (this.isExpandedDesktop() && !this.searchWrapper.contains(e.target)) {
        this.collapseDesktop();
      }
    });

    // ESC - sbalit
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isExpandedDesktop()) {
        this.collapseDesktop();
      }
    });
  }

  initMobile() {
    // Pokud input už má hodnotu (např. po vyhledání), zobrazit hodnotu místo placeholderu
    this.updateValueDisplayMobile();
    if (this.searchInputMobile.value.trim()) {
      this.searchWrapperMobile.classList.add('has-value');
    }

    // Kliknutí na ikonu - rozšířit nebo submit
    this.searchIconMobile.addEventListener('click', (e) => {
      e.stopPropagation();
      if (this.isExpandedMobile()) {
        this.submitSearchMobile();
      } else {
        this.expandMobile();
      }
    });

    this.searchIconMobile.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.searchIconMobile.click();
      }
    });

    // Kliknutí na compact - rozšířit
    if (this.searchCompactMobile) {
      this.searchCompactMobile.addEventListener('click', (e) => {
        if (!this.searchIconMobile.contains(e.target) && !this.searchCloseMobile?.contains(e.target)) {
          if (!this.isExpandedMobile()) {
            this.expandMobile();
          }
        }
      });
    }

    // Kliknutí na křížek - zavřít
    if (this.searchCloseMobile) {
      this.searchCloseMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.collapseMobile();
      });
    }

    // Aktualizovat třídu a zobrazení hodnoty při psaní
    this.searchInputMobile.addEventListener('input', () => {
      this.updateValueDisplayMobile();
      if (this.searchInputMobile.value.trim()) {
        this.searchWrapperMobile.classList.add('has-value');
      } else {
        this.searchWrapperMobile.classList.remove('has-value');
      }
    });

    // Enter - submit
    this.searchInputMobile.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.submitSearchMobile();
      }
    });

    // Kliknutí mimo - sbalit
    document.addEventListener('click', (e) => {
      if (this.isExpandedMobile() && !this.searchWrapperMobile.contains(e.target)) {
        this.collapseMobile();
      }
    });

    // ESC - sbalit
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isExpandedMobile()) {
        this.collapseMobile();
      }
    });
  }

  // Desktop methods
  isExpandedDesktop() {
    return this.searchWrapper.getAttribute('data-expanded') === 'true';
  }

  expandDesktop() {
    document.dispatchEvent(new CustomEvent('contact-dropdown:close'));
    if (this.desktopCollapseTimer) {
      clearTimeout(this.desktopCollapseTimer);
      this.desktopCollapseTimer = null;
    }
    this.searchWrapper.classList.remove('is-closing');
    this.searchWrapper.setAttribute('data-expanded', 'true');
    setTimeout(() => {
      this.searchInput.focus();
      if (this.searchInput.value.trim()) {
        this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }, 100);
  }

  collapseDesktop() {
    if (!this.isExpandedDesktop() || this.searchWrapper.classList.contains('is-closing')) return;

    this.searchWrapper.classList.add('is-closing');
    this.searchInput.blur();

    this.desktopCollapseTimer = setTimeout(() => {
      this.desktopCollapseTimer = null;
      this.searchWrapper.setAttribute('data-expanded', 'false');
      this.searchWrapper.classList.remove('is-closing', 'has-value');
      this.searchInput.value = '';
      this.updateValueDisplay();
    }, this.animationMs);
  }

  updateValueDisplay() {
    if (this.searchValue) {
      const value = this.searchInput.value.trim();
      if (value) {
        this.searchValue.textContent = value;
      } else {
        this.searchValue.textContent = '';
      }
    }
  }

  submitSearchDesktop() {
    if (this.searchInput.value.trim()) {
      this.searchForm.requestSubmit ? this.searchForm.requestSubmit() : this.searchForm.submit();
    }
  }

  // Mobile methods
  isExpandedMobile() {
    return this.searchWrapperMobile.getAttribute('data-expanded') === 'true';
  }

  expandMobile() {
    document.dispatchEvent(new CustomEvent('contact-dropdown:close'));
    if (this.mobileCollapseTimer) {
      clearTimeout(this.mobileCollapseTimer);
      this.mobileCollapseTimer = null;
    }
    this.searchWrapperMobile.classList.remove('is-closing');
    this.searchWrapperMobile.setAttribute('data-expanded', 'true');
    setTimeout(() => {
      this.searchInputMobile.focus();
      if (this.searchInputMobile.value.trim()) {
        this.searchInputMobile.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }, 100);
  }

  collapseMobile() {
    if (!this.isExpandedMobile() || this.searchWrapperMobile.classList.contains('is-closing')) return;

    this.searchWrapperMobile.classList.add('is-closing');
    this.searchInputMobile.blur();

    this.mobileCollapseTimer = setTimeout(() => {
      this.mobileCollapseTimer = null;
      this.searchWrapperMobile.setAttribute('data-expanded', 'false');
      this.searchWrapperMobile.classList.remove('is-closing', 'has-value');
      this.searchInputMobile.value = '';
      this.updateValueDisplayMobile();
    }, this.animationMs);
  }

  updateValueDisplayMobile() {
    if (this.searchValueMobile) {
      const value = this.searchInputMobile.value.trim();
      if (value) {
        this.searchValueMobile.textContent = value;
      } else {
        this.searchValueMobile.textContent = '';
      }
    }
  }

  submitSearchMobile() {
    if (this.searchInputMobile.value.trim()) {
      this.searchFormMobile.requestSubmit ? this.searchFormMobile.requestSubmit() : this.searchFormMobile.submit();
    }
  }
}

function initHeaderSearchExpand() {
  if (window.__headerSearchExpandInitialized) return;
  window.__headerSearchExpandInitialized = true;
  new HeaderSearchExpand();
}

window.initHeaderSearchExpand = initHeaderSearchExpand;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderSearchExpand, { once: true });
} else {
  initHeaderSearchExpand();
}
